import { Component, inject } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Auth } from 'aws-amplify';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';

import { InputTextComponent } from '../../controls/input-text/input-text.component';
import { RouterLink } from '@angular/router';
import { ButtonDirective } from 'primeng/button';

export interface ForgotPasswordForm {
    email: FormControl<string>;
}

@Component({
    selector: 'app-forgot-password',
    templateUrl: './forgot-password.component.html',
    imports: [
    InputTextComponent,
    ReactiveFormsModule,
    RouterLink,
    ButtonDirective
],
})
export class ForgotPasswordComponent {
	private dynamicDialogRef = inject(DynamicDialogRef);

	isForgotPasswordEmailSent: boolean;
	email: string;
	isError: boolean;
	errorMessage: string;
	forgotPasswordForm: FormGroup<ForgotPasswordForm>;


	constructor() {
		this.forgotPasswordForm = new FormGroup<ForgotPasswordForm>({
			email: new FormControl<string>('', [
				Validators.required,
				Validators.maxLength(250),
				Validators.email])
		});
	}

	confirm(): void {
		if (!this.isForgotPasswordEmailSent) {
			if (this.forgotPasswordForm.invalid) {
				return;
			}

			const email = this.forgotPasswordForm.controls.email.value;
			Auth.forgotPassword(email)
				.then(() => {
					this.isForgotPasswordEmailSent = true;
					this.email = email;
				})
				.catch(() => {
					this.isForgotPasswordEmailSent = true;
					this.email = email;
				});
		} else {
			this.redirectToPasswordResetPage();
		}
	}

	redirectToPasswordResetPage(): void {
		this.dynamicDialogRef.close({
			username: ''
		});
	}

	cancel(): void {
		this.dynamicDialogRef.close();
	}
}
